import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel'
export class SuccessStoryDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            title: '',
            description: '',
            carrouselUrls: []
        };
        this.renderCarrousel = this.renderCarrousel.bind(this);

    };


    renderCarrousel(imgs) {
        var content = imgs.map((i, index) =>
            <Carousel.Item key={index}>
                <img className="img-fluid" src={i} alt="image" />
            </Carousel.Item>
        );
        return (
            <Carousel>
                {content}
            </Carousel>
        );
    }

    render() {
        return (
            <div>
                {this.renderCarrousel(this.props.story.imgsUrls)}
            </div>
        );
    };
}
